import IconRenderer, { Icon } from './IconRenderer'

export type IconGridItem = {
  title: string
  icon: Icon
  description: string
}

interface FeatureHeroProps extends React.HTMLAttributes<HTMLUListElement> {
  items: IconGridItem[]
}

const IconGrid = ({
  items,
  className,
  ...props
}: FeatureHeroProps): JSX.Element | null => {
  return items.length > 0 ? (
    <ul
      className={`grid md:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-16 ${
        className || ''
      }`}
      {...props}
    >
      {items.map((item, index) => (
        <li key={`${index}-${item.title}`}>
          <div className='flex items-center'>
            <IconRenderer
              icon={item.icon}
              className='h-8 w-auto mr-3 text-blue'
            />

            <h3 className='h5-size'>{item.title}</h3>
          </div>

          <p className='spacer-3xs opacity-60'>{item.description}</p>
        </li>
      ))}
    </ul>
  ) : null
}

export default IconGrid
